import styled from 'styled-components';

export const TableContainer = styled.div`
  td {
    height: 58px !important;
  }
  tr:not([id]) {
    border-top: 2px solid white;
  }
`;
